import { gql } from '@apollo/client';

export default gql`
  mutation ImportDocumentsFromCourse(
    $courseId: String!
    $subjectId: String!
    $input: ImportDocumentsInput!
  ) {
    documents(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/import"
        method: "POST"
      ) {
      NoResponse
    }
  }
`;
